import API from "core/api/axios/base";
import ChangePasswordErrorHandler from "core/api/handler/ChangePasswordErrorHandler";

export default function ChangePassword(data, token) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_CLIENT_KEY,
      Authorization: "Bearer " + token,
      "x-accesstoken": token
    },
    withCredentials: false
  };
  config.headers['x-credentials-key'] = process.env.REACT_APP_X_CREDENTIALS_KEY;
  
  return API.patch(`${process.env.REACT_APP_CHANGE_PASSWORD_URL}`, data, config)
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const errorHandler = ChangePasswordErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}
